export default "__VITE_ASSET__BrOVN_LU__"